import React from 'react';
import PropTypes from 'prop-types';

import SubFeatureItem from '../SubFetaureItem';
import subFeatureItemPropType from '../../../common/propTypes/subFeatureItemPropType';

import './subFeature.scss';

const SubFeature = (props) => {
    const deviceType = props.platform === 'desktop' || props.platform === 'tablet' ? 'desktop' : 'mobile';
    return (
        <div>
            { props.data.map((item, index) =>
                // eslint-disable-next-line react/no-array-index-key
                (<div key={index} styleName="sub_feature">
                    <SubFeatureItem deviceType={deviceType} data={item} />
                </div>))}
        </div>
    );
};

SubFeature.propTypes = {
    data: PropTypes.arrayOf(subFeatureItemPropType).isRequired,
    platform: PropTypes.string.isRequired,
};

export default SubFeature;
